import { render, staticRenderFns } from "./DocumentData.vue?vue&type=template&id=9795873c&scoped=true"
import script from "./DocumentData.vue?vue&type=script&lang=js"
export * from "./DocumentData.vue?vue&type=script&lang=js"
import style0 from "./DocumentData.vue?vue&type=style&index=0&id=9795873c&prod&scoped=true&lang=css"
import style1 from "./DocumentData.vue?vue&type=style&index=1&id=9795873c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9795873c",
  null
  
)

export default component.exports